<template>
  <div>
    <!-- Suspended/Blocked -->
    <v-alert :value="isSuspended || isBlocked" type="error">
      <span class="subheading">
        {{ candidate.profile.fullName }} has been {{ isBlocked ? 'blocked' : 'suspended' }}
      </span>
      <can I="edit" a="Candidate">
        <v-btn @click="reactivate" color="primary">
          <v-icon left>mdi-email</v-icon> Reactivate Candidate
        </v-btn>
      </can>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: { candidate: { type: Object, required: true } },
  computed: {
    isSuspended() {
      return this.candidate && this.candidate.isSuspended
    },
    isBlocked() {
      return this.candidate && this.candidate.isBlocked
    },
  },
  methods: {
    reactivate() {
      this.$store
        .dispatch('admin/candidates/reactivate', this.$route.params.id)
        .then(() => this.$store.dispatch('snackbarSuccess', 'Activated'))
        .catch(() => this.$store.dispatch('snackbarError', 'Activation Failed'))
        .finally(() => this.$emit('refresh'))
    },
  },
}
</script>
